"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _params = require("hub-http/helpers/params");

var _trackingParams = require("../../selectors/trackingParams");

var useShortlinkParams = function useShortlinkParams() {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var trackingParams = (0, _reactRedux.useSelector)(_trackingParams.getTrackingParams);
  var shortlinkParams = (0, _react.useMemo)(function () {
    var currentParams = (0, _params.parse)(search.slice(1));
    return (0, _extends2.default)({}, trackingParams, currentParams);
  }, [search, trackingParams]);
  return shortlinkParams;
};

var _default = useShortlinkParams;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useShortlinkParams.js
// module id = 602
// module chunks = 209 210 211 212